import { VeltProvider, VeltComments, VeltCommentsSidebar, VeltCursor, VeltHuddle, useVeltClient} from '@veltdev/react';
import { useEffect } from 'react'
import YourAuthComponent from './components/YourAuthComponent';
import YourDocument from './components/YourDocument';

function App() {

  const { client } = useVeltClient();

  useEffect(()=>{
    if(client){
      const arrowElement = client.getArrowElement();
      arrowElement.allowedElementIds(['SITE_CONTAINER']);
    }
  })

  return (
    <VeltProvider apiKey="j3AwoBkuQMTEgeqrmPve">
      <VeltHuddle/>
      <VeltCursor />
      <VeltComments textMode={true} sidebarButtonOnCommentDialog={true} autoCategorize={true} allowedElementIds={['SITE_CONTAINER']}/>
      <VeltCommentsSidebar />
      <YourAuthComponent/>
      <YourDocument/>
    </VeltProvider>

  );
}

export default App;

